import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google'; // Import Google OAuth provider
import ShopContextProvider from './context/ShopContext.jsx';
// import HeartRain from './components/HeartRain.jsx';
// Ensure Google Client ID is correctly passed through the environment variables
// const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    {/* Wrap the whole app with GoogleOAuthProvider and ShopContextProvider */}
    <GoogleOAuthProvider clientId={"1083998030025-hb03bhfse65e4gjs7n687kpgo0dbcmm9.apps.googleusercontent.com"}>
     {/* <HeartRain /> */}
      <ShopContextProvider>
        <App />
      </ShopContextProvider>
    </GoogleOAuthProvider>
  </BrowserRouter>
);
